// Opções do WhatsApp Baileys agrupadas como aparecem na tela (criação da caixa e configurações).
// Um lugar só: antes cada tela tinha a sua lista e uma delas ficou com o rótulo errado do readStatus.
//
// - atendimento: muda o dia a dia de quem atende; sempre à vista.
// - historico: só vale na primeira conexão (ler o QR / digitar o código); sub-opções recuadas.
// - mais: técnicas, com efeito colateral; recolhidas, cada uma com o aviso do efeito.
//
// Recebe o `t` do i18n e devolve os textos já traduzidos (chaves literais: o lint confere se existem).
// description: o que a opção faz. hint: o efeito colateral, mostrado como aviso.
export const baileysConfigSections = (t, maxImportDays = 30) => [
  {
    id: 'atendimento',
    title: t('INBOX_MGMT.BAILEYS_SETTINGS.SECTIONS.SERVICE'),
    items: [
      {
        key: 'signMsg',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.SIGN_MSG.LABEL'),
        description: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.SIGN_MSG.DESCRIPTION'
        ),
        type: 'checkbox',
      },
      {
        key: 'rejectCall',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.REJECT_CALL.LABEL'),
        description: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.REJECT_CALL.DESCRIPTION'
        ),
        placeholder: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.REJECT_CALL.PLACEHOLDER'
        ),
        type: 'checkbox',
        hasMessage: true,
      },
      {
        key: 'receiveGroups',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.RECEIVE_GROUPS.LABEL'),
        description: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.RECEIVE_GROUPS.DESCRIPTION'
        ),
        type: 'checkbox',
      },
    ],
  },
  {
    id: 'historico',
    title: t('INBOX_MGMT.BAILEYS_SETTINGS.SECTIONS.HISTORY'),
    subtitle: t('INBOX_MGMT.BAILEYS_SETTINGS.SECTIONS.HISTORY_SUBTITLE'),
    items: [
      {
        key: 'importMessageHistory',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.IMPORT_HISTORY.LABEL'),
        description: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.IMPORT_HISTORY.DESCRIPTION'
        ),
        type: 'checkbox',
      },
      {
        key: 'historyDaysLimit',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.HISTORY_DAYS.LABEL'),
        description: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.HISTORY_DAYS.DESCRIPTION',
          { max: maxImportDays }
        ),
        invalid: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.HISTORY_DAYS.INVALID', {
          max: maxImportDays,
        }),
        type: 'number',
        min: 1,
        max: maxImportDays,
        showIf: 'importMessageHistory',
        nested: true,
      },
      {
        key: 'importGroupHistory',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.IMPORT_GROUPS.LABEL'),
        type: 'checkbox',
        showIf: 'importMessageHistory',
        hideIf: 'receiveGroups',
        nested: true,
      },
    ],
  },
  {
    id: 'mais',
    title: t('INBOX_MGMT.BAILEYS_SETTINGS.SECTIONS.MORE'),
    collapsible: true,
    items: [
      {
        key: 'alwaysOnline',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.ALWAYS_ONLINE.LABEL'),
        hint: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.ALWAYS_ONLINE.HINT'),
        type: 'checkbox',
      },
      {
        key: 'readMessages',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.READ_MESSAGES.LABEL'),
        hint: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.READ_MESSAGES.HINT'),
        type: 'checkbox',
      },
      {
        key: 'readStatus',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.READ_STATUS.LABEL'),
        description: t(
          'INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.READ_STATUS.DESCRIPTION'
        ),
        type: 'checkbox',
      },
      {
        key: 'reuseMedia',
        label: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.REUSE_MEDIA.LABEL'),
        hint: t('INBOX_MGMT.BAILEYS_SETTINGS.OPTIONS.REUSE_MEDIA.HINT'),
        type: 'checkbox',
      },
    ],
  },
];

// Opção visível dado o estado atual das configurações (showIf: só com a outra ligada;
// hideIf: some com a outra ligada — grupos no histórico não valem ignorando grupos).
export const isConfigItemVisible = (item, config) =>
  (!item.showIf || Boolean(config[item.showIf])) &&
  (!item.hideIf || !config[item.hideIf]);
